import { DripsyProvider } from 'dripsy';
import React, { createContext } from 'react';
import { useStore } from '../../store/store';
import { useBrandedTheme } from './useAppTheme';

export enum ThemeColor {
  $primary = '$primary',
  $secondary = '$secondary',
  $accent = '$accent',
  // Text
  $textPrimary = '$textPrimary',
  $textSecondary = '$textSecondary',
  $textDisable = '$textDisable',
  $textButtonPrimary = '$textButtonPrimary',
  $textButtonSecondary = '$textButtonSecondary',
  // Icon
  $iconDefault = '$iconDefault',
  $iconFocused = '$iconFocused',
  // Border
  $borderPrimary = '$borderPrimary',
  // Background
  $backgroundPrimary = '$backgroundPrimary',
  $backgroundSecondary = '$backgroundSecondary',
  // Line
  $lineThin = '$lineThin',
  $lineThick = '$lineThick',
  // Status
  $success = '$success',
  $danger = '$danger',
  $warning = '$warning',
  $info = '$info',
  $disable = '$disable',
  // Others
  $hyperlink = '$hyperlink',
}

export interface ColorTheme extends Record<ThemeColor, string> {}

export const ThemeProvider: React.FC = (props) => {
  const { appTheme } = useBrandedTheme();
  return <DripsyProvider theme={appTheme}>{props.children}</DripsyProvider>;
};
